import { render } from "./profilePost2.vue?vue&type=template&id=0e1b64b0"
import script from "./profilePost2.vue?vue&type=script&lang=js"
export * from "./profilePost2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__